import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Collapse,
  IconButton,
  Divider,
} from "@mui/material";
import { ExpandLess, ExpandMore, Menu } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const MenuLateral = ({ darkMode }) => {
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState({});
  const [menuAberto, setMenuAberto] = useState(true);

  const toggleMenu = () => setMenuAberto(!menuAberto);
  const toggleSubMenu = (menu) => {
    setOpenMenus((prev) => ({ ...prev, [menu]: !prev[menu] }));
  };

  const menuItems = [
    { text: "Cirurgias", path: "/cirurgias", subitems: [] },
    { text: "Convênio", path: "/convenio", subitems: [] },
    { text: "Hospital", path: "/hospital", subitems: [] },
    {
      text: "Instrumentador",
      subitems: [{ text: "Cadastrar", path: "/instrumentador" }],
    },
    {
      text: "Médico",
      subitems: [{ text: "Cadastrar", path: "/medico" }],
    },
    {
      text: "Paciente",
      subitems: [{ text: "Cadastrar", path: "/paciente" }],
    },
    {
      text: "Usuário",
      subitems: [{ text: "Cadastrar", path: "/usuario" }],
    },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: menuAberto ? 240 : 60,
        flexShrink: 0,
        transition: "width 0.3s",
        "& .MuiDrawer-paper": {
          width: menuAberto ? 240 : 60,
          boxSizing: "border-box",
          backgroundColor: darkMode ? "#1E1E1E" : "#f8f9fa",
          color: darkMode ? "#ffffff" : "#000000",
        },
      }}
    >
      {/* Botão para recolher/expandir o menu */}
      <IconButton onClick={toggleMenu} sx={{ margin: "10px auto" }}>
        <Menu />
      </IconButton>
      <Divider />

      <List>
        {menuItems.map((item) => (
          <React.Fragment key={item.text}>
            <ListItem
              button
              onClick={() =>
                item.subitems.length
                  ? toggleSubMenu(item.text)
                  : navigate(item.path)
              }
            >
              <ListItemText primary={item.text} />
              {item.subitems.length > 0 &&
                (openMenus[item.text] ? <ExpandLess /> : <ExpandMore />)}
            </ListItem>

            <Collapse in={openMenus[item.text]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {item.subitems.map((sub) => (
                  <ListItem
                    button
                    key={sub.text}
                    sx={{ pl: 4 }}
                    onClick={() => navigate(sub.path)}
                  >
                    <ListItemText primary={sub.text} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
};

export default MenuLateral;
